<template>
<div>
    <!-- loader -->
    <Loader />
    <!-- loader -->

    <!-- login-area -->
    <section class="login-area">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="form-area">
                        <div class="login-form">
                            <div class="form-logo">
                                <h3>Check your email</h3>
                            </div>
                            <div class="check-emails">
                                <div class="saneaemail">
                                    <p><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewbox="0 0 24 24" version="1.1">
                                            <title>icons/stroke/checkmark-circle</title>
                                            <defs>
                                                <path d="M14.7046,8.3945 L10.9206,13.3635 L9.2876,11.2775 C8.9476,10.8415 8.3176,10.7655 7.8836,11.1065 C7.4486,11.4465 7.3716,12.0755 7.7126,12.5095 L10.1436,15.6165 C10.3336,15.8585 10.6236,15.9995 10.9316,15.9995 L10.9386,15.9995 C11.2476,15.9985 11.5396,15.8525 11.7266,15.6055 L16.2956,9.6055 C16.6306,9.1655 16.5456,8.5395 16.1056,8.2045 C15.6646,7.8695 15.0386,7.9555 14.7046,8.3945 M12,20 C7.589,20 4,16.411 4,12 C4,7.589 7.589,4 12,4 C16.411,4 20,7.589 20,12 C20,16.411 16.411,20 12,20 M12,2 C6.477,2 2,6.478 2,12 C2,17.522 6.477,22 12,22 C17.523,22 22,17.522 22,12 C22,6.478 17.523,2 12,2" id="path-1" />
                                            </defs>
                                            <g id="icons/stroke/checkmark-circle" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <mask id="mask-2" fill="white">
                                                    <use xlink:href="#path-1" />
                                                </mask>
                                                <use id="🎨-Icon-Сolor" fill="#180660" xlink:href="#path-1" />
                                            </g>
                                        </svg>We've sent an email on {{ forgotEmail }}.</p>
                                </div>
                                <div class="check-text">
                                    <p>Click the link in the email to reset your password.</p>
                                    <p>If you don't see the email, check other places it might be, like your junk, spam, social, or other folders. The OTP will expire in 2 minutes.</p>
                                </div>
                                <router-link class="login-btns" to="/login">Continue</router-link>
                                <router-link class="rec-email" to="/forgot-password">Back</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- login-area -->
</div>
</template>

<script>
// import $ from "jquery";
import { onMounted } from "vue";
// import { useRouter } from 'vue-router';
import Loader from "@/components/Loader";
// import axios from "axios";
// console.log(localStorage);
export default {
    components: {
        Loader
    },
    setup() {
        let base_url = "http://api.streamly.com/uploads/";
        let forgotEmail = localStorage.getItem("forgot_email") || "";
        // console.log(forgotPhone);
        // const router = useRouter();

        onMounted(() => {
            setTimeout(() => {
                window.showHideMainLoader(false);
            }, 500);
        });

        return {
            base_url,
            forgotEmail
        };
    },
};
</script>
